<template>
    <div>
        <el-form :inline="true" :model="queryParams" size="small" style="text-align: left; margin-top: 5px">
            <el-form-item label="学校选择">
                <el-select v-model="queryParams.schoolId" placeholder="请选择学校" :clearable="!schoolLocked" filterable :disabled="schoolLocked" @change="getList">
                    <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="券名称">
                <el-input v-model="queryParams.couponName" placeholder="券名称" clearable @keyup.enter.native="getList" />
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="queryParams.status" placeholder="全部" clearable>
                    <el-option label="待发布" value="0" />
                    <el-option label="已发布" value="1" />
                    <el-option label="已取消" value="2" />
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" @click="getList">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button type="primary" plain icon="el-icon-plus" size="mini" :disabled="!queryParams.schoolId" @click="openForm()">新增优惠券</el-button>
            </el-col>
        </el-row>

        <el-table :data="list" border style="width: 100%">
            <el-table-column label="名称" prop="couponName" align="center" :show-overflow-tooltip="true" />
            <el-table-column label="金额" prop="money" align="center" width="90" />
            <el-table-column label="门槛" prop="minAmount" align="center" width="90" />
            <el-table-column label="适用模块" align="center" min-width="160" :show-overflow-tooltip="true">
                <template slot-scope="scope">{{ applicableText(scope.row.applicableTypes) }}</template>
            </el-table-column>
            <el-table-column label="有效天数" prop="validDays" align="center" width="90" />
            <el-table-column label="库存" align="center" width="90">
                <template slot-scope="scope">
                    <span v-if="scope.row.totalStock == null || scope.row.totalStock < 0">不限</span>
                    <span v-else>{{ scope.row.totalStock }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" width="100">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.status === '0'" size="small">待发布</el-tag>
                    <el-tag v-else-if="scope.row.status === '1'" size="small" type="success">已发布</el-tag>
                    <el-tag v-else size="small" type="info">已取消</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="学校" align="center" min-width="140">
                <template slot-scope="scope">{{ schoolName(scope.row.schoolId) }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="240">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" icon="el-icon-edit" @click="openForm(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.status !== '1'" size="mini" type="text" @click="changeStatus(scope.row, '1')">发布</el-button>
                    <el-button v-if="scope.row.status === '1'" size="mini" type="text" @click="changeStatus(scope.row, '2')">取消发布</el-button>
                    <el-button v-if="scope.row.status === '0'" size="mini" type="text" style="color: #f56c6c" @click="remove(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                style="margin-top: 16px; text-align: right"
                layout="total, prev, pager, next"
                :current-page="queryParams.pageNum"
                :page-size="queryParams.pageSize"
                :total="total"
                @current-change="handlePageChange">
        </el-pagination>

        <el-dialog :title="dialogTitle" :visible.sync="dialogOpen" width="560px" @close="resetForm">
            <el-form ref="couponForm" :model="form" :rules="rules" label-width="100px" size="small">
                <el-form-item label="学校" prop="schoolId">
                    <el-select v-model="form.schoolId" placeholder="请选择学校" :disabled="!!form.id || schoolLocked" filterable>
                        <el-option
                                v-for="item in schoolList"
                                :key="item.schoolId"
                                :label="item.schoolName"
                                :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="券名称" prop="couponName">
                    <el-input v-model="form.couponName" maxlength="20" :disabled="publishedLocked" />
                </el-form-item>
                <el-form-item label="说明" prop="couponExplain">
                    <el-input v-model="form.couponExplain" maxlength="30" :disabled="publishedLocked" />
                </el-form-item>
                <el-form-item label="金额" prop="money">
                    <el-input-number v-model="form.money" :min="0.01" :step="0.01" :precision="2" :disabled="publishedLocked" />
                    <div style="color:#909399;font-size:12px;">最小 0.01 元，可低于 1 元</div>
                </el-form-item>
                <el-form-item label="使用门槛" prop="minAmount">
                    <el-input-number v-model="form.minAmount" :min="0" :precision="2" :disabled="publishedLocked" />
                </el-form-item>
                <el-form-item label="有效天数" prop="validDays">
                    <el-input-number v-model="form.validDays" :min="1" :disabled="publishedLocked" />
                </el-form-item>
                <el-form-item label="库存">
                    <el-input-number v-model="form.totalStock" :min="-1" :disabled="publishedLocked" />
                    <div style="color:#909399;font-size:12px;">空或不填表示不限</div>
                </el-form-item>
                <el-form-item label="每人限领" prop="perUserLimit">
                    <el-input-number v-model="form.perUserLimit" :min="1" :disabled="publishedLocked" />
                </el-form-item>
                <el-form-item label="使用规则" required>
                    <el-checkbox :indeterminate="applicableIndeterminate" v-model="applicableAllChecked">全部模块</el-checkbox>
                    <div style="margin-top: 8px">
                        <el-checkbox-group v-model="form.applicableTypeList">
                            <el-checkbox v-for="item in orderModules" :key="item" :label="item">{{ item }}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <div style="color:#909399;font-size:12px;">不勾选任何模块视为全部可用。已发布券也可改此项。</div>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="form.sortNum" :min="0" />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogOpen = false">取 消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'
export default {
    name: 'Coupon',
    computed: {
        schoolLocked() {
            return isSchoolScoped()
        },
        publishedLocked() {
            return this.form.status === '1' || this.form.status === '2'
        },
        applicableAllChecked: {
            get() {
                return this.form.applicableTypeList.length === this.orderModules.length
            },
            set(val) {
                this.form.applicableTypeList = val ? this.orderModules.slice() : []
            }
        },
        applicableIndeterminate() {
            const n = this.form.applicableTypeList.length
            return n > 0 && n < this.orderModules.length
        }
    },
    data() {
        return {
            schoolList: [],
            list: [],
            total: 0,
            dialogOpen: false,
            dialogTitle: '新增优惠券',
            submitLoading: false,
            orderModules: ['代取快递', '代取外卖', '跑腿打印', '万能帮', '宿舍服务', '快递集送'],
            queryParams: {
                schoolId: null,
                couponName: '',
                status: '',
                pageNum: 1,
                pageSize: 10
            },
            form: this.emptyForm(),
            rules: {
                schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }],
                couponName: [{ required: true, message: '请输入券名称', trigger: 'blur' }],
                money: [{ required: true, message: '请输入金额', trigger: 'blur' }],
                minAmount: [{ required: true, message: '请输入门槛', trigger: 'blur' }],
                validDays: [{ required: true, message: '请输入有效天数', trigger: 'blur' }],
                perUserLimit: [{ required: true, message: '请输入每人限领', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.getSchoolList()
    },
    methods: {
        emptyForm() {
            return {
                id: null,
                schoolId: null,
                couponName: '',
                couponExplain: '',
                money: 1,
                minAmount: 0,
                validDays: 3,
                totalStock: undefined,
                perUserLimit: 1,
                sortNum: 0,
                status: '0',
                applicableTypeList: ['代取快递', '代取外卖', '跑腿打印', '万能帮', '宿舍服务', '快递集送']
            }
        },
        schoolName(schoolId) {
            const found = this.schoolList.find(item => Number(item.schoolId) === Number(schoolId))
            return found ? found.schoolName : (schoolId || '未绑定')
        },
        applicableText(raw) {
            if (!raw) {
                return '全部'
            }
            return raw
        },
        parseApplicable(raw) {
            if (!raw) {
                return this.orderModules.slice()
            }
            const picked = String(raw).split(',').map(item => item.trim()).filter(item => this.orderModules.indexOf(item) >= 0)
            return picked.length ? picked : this.orderModules.slice()
        },
        async getSchoolList() {
            const res = await this.$http.get('/school/AppGetCampusSchoolList')
            if (res.data.code === 200) {
                this.schoolList = lockSchoolOptions(res.data.data || [])
                if (isSchoolScoped() && getBoundSchoolId() != null) {
                    this.queryParams.schoolId = getBoundSchoolId()
                    this.getList()
                }
            }
        },
        async getList() {
            const res = await this.$http.get('/admin/coupon/list', { params: this.queryParams })
            if (res.data.code === 200) {
                const page = res.data.data || {}
                this.list = page.children || []
                this.total = page.total || 0
            } else {
                this.$message.error(res.data.msg || '查询失败')
            }
        },
        resetQuery() {
            this.queryParams.couponName = ''
            this.queryParams.status = ''
            this.queryParams.pageNum = 1
            if (!this.schoolLocked) {
                this.queryParams.schoolId = null
                this.list = []
                this.total = 0
                return
            }
            this.getList()
        },
        handlePageChange(page) {
            this.queryParams.pageNum = page
            this.getList()
        },
        openForm(row) {
            if (row) {
                this.dialogTitle = '编辑优惠券'
                this.form = Object.assign(this.emptyForm(), row)
                this.form.applicableTypeList = this.parseApplicable(row.applicableTypes)
            } else {
                this.dialogTitle = '新增优惠券'
                this.form = this.emptyForm()
                this.form.schoolId = this.queryParams.schoolId
            }
            this.dialogOpen = true
        },
        resetForm() {
            this.form = this.emptyForm()
            if (this.$refs.couponForm) {
                this.$refs.couponForm.clearValidate()
            }
        },
        submitForm() {
            this.$refs.couponForm.validate(async valid => {
                if (!valid) {
                    return
                }
                this.submitLoading = true
                try {
                    const payload = Object.assign({}, this.form)
                    const picked = payload.applicableTypeList || []
                    payload.applicableTypes = picked.length === 0 || picked.length === this.orderModules.length
                        ? ''
                        : picked.join(',')
                    delete payload.applicableTypeList
                    const url = this.form.id ? '/admin/coupon/update' : '/admin/coupon/insert'
                    const res = await this.$http.post(url, payload)
                    if (res.data.code === 200) {
                        this.$message.success('保存成功')
                        this.dialogOpen = false
                        this.getList()
                    } else {
                        this.$message.error(res.data.msg || '保存失败')
                    }
                } finally {
                    this.submitLoading = false
                }
            })
        },
        async changeStatus(row, status) {
            const res = await this.$http.post('/admin/coupon/changeStatus', null, {
                params: { id: row.id, status }
            })
            if (res.data.code === 200) {
                this.$message.success('已更新')
                this.getList()
            } else {
                this.$message.error(res.data.msg || '更新失败')
            }
        },
        remove(row) {
            this.$confirm('确认删除该待发布优惠券？', '提示', { type: 'warning' }).then(async () => {
                const res = await this.$http.post('/admin/coupon/delete', null, { params: { id: row.id } })
                if (res.data.code === 200) {
                    this.$message.success('已删除')
                    this.getList()
                } else {
                    this.$message.error(res.data.msg || '删除失败')
                }
            }).catch(() => {})
        }
    }
}
</script>
